"use strict";

exports.__esModule = true;
var _Box = require("./Box");
Object.keys(_Box).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Box[key]) return;
  exports[key] = _Box[key];
});